const Configure = function (appSecret, sandBox) {
  this.appSecret = appSecret;
  this.sandBox = sandBox;
};

module.exports = Configure;
